export const FILE_VAULT_ACTION_KEYS = [
  // The row orders its applicable entries itself (by label, with each row
  // type's trailing actions last — see TRAILING_ROW_ACTIONS in
  // FileVaultList.vue); the last `inlineActionCount` render as inline icon
  // buttons, the rest fold into the "⋯" menu (Delete isolated at the bottom
  // behind a divider). 'preview' renders as "Unpack" for archives,
  // 'download-folder' ("Download as zip") only applies to directories.
  // 'ask-ai' opens the GAIA chat scoped to the row (files and folders alike).
  'ask-ai',
  'preview',
  'download',
  'download-folder',
  'versions',
  'convert-to-docx',
  'convert-to-contract',
  'export-to-gaia',
  // Contracts and files (archives aside): start a signing request with the
  // row prefilled — a contract with all its files, a file on its own.
  'sign',
  'rename',
  'move',
  'share',
  'change-owner',
  // Contracts only: upload a document into the contract or file one from the
  // vault.
  'add-file',
  'delete',
] as const;

export type FileVaultActionKey = (typeof FILE_VAULT_ACTION_KEYS)[number];

export const DEFAULT_FILE_VAULT_ACTIONS: FileVaultActionKey[] = [...FILE_VAULT_ACTION_KEYS];
